/**
 * Collections Carousel Component
 * Handles desktop carousel and mobile grid view for exactly 6 collections
 */
class CollectionsCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-carousel-track]');
    this.prevBtn = this.querySelector('.collections-carousel__btn--prev');
    this.nextBtn = this.querySelector('.collections-carousel__btn--next');
    
    if (!this.track) return;
    
    this.scrollAmount = 300;
    this.isMobile = window.innerWidth <= 768;
    
    this.#init();
  }
  
  #init() {
    // Setup desktop carousel controls
    this.prevBtn?.addEventListener('click', () => this.#scroll('prev'));
    this.nextBtn?.addEventListener('click', () => this.#scroll('next'));
    
    if (this.track) {
      this.track.addEventListener('scroll', () => this.#updateButtons());
      this.#setupDragScroll();
    }
    
    // Handle resize
    window.addEventListener('resize', () => this.#handleResize());
    
    // Initial update
    this.#updateButtons();
  }
  
  #scroll(direction) {
    const scrollAmount = direction === 'prev' ? -this.scrollAmount : this.scrollAmount;
    this.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
  
  #updateButtons() {
    if (!this.prevBtn || !this.nextBtn || this.isMobile) return;
    
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    
    this.prevBtn.disabled = scrollLeft <= 0;
    this.nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
  }
  
  #setupDragScroll() {
    if (this.isMobile) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;
    
    this.track.addEventListener('mousedown', (e) => {
      isDown = true;
      this.track.style.cursor = 'grabbing';
      startX = e.pageX - this.track.offsetLeft;
      scrollLeft = this.track.scrollLeft;
    });
    
    this.track.addEventListener('mouseleave', () => {
      isDown = false;
      this.track.style.cursor = 'grab';
    });
    
    this.track.addEventListener('mouseup', () => {
      isDown = false;
      this.track.style.cursor = 'grab';
    });
    
    this.track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.track.offsetLeft;
      const walk = (x - startX) * 2;
      this.track.scrollLeft = scrollLeft - walk;
    });
  }
  
  #handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;
    
    // If switching between mobile and desktop, update button states
    if (wasMobile !== this.isMobile) {
      this.#updateButtons();
    }
  }
}

// Register custom element
customElements.define('collections-carousel', CollectionsCarousel);

